const listeners = new Set();
let socket = null;
let currentBranchId = null;
let reconnectTimer = null;
let reconnectAttempts = 0;

const clearReconnect = () => {
  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }
};

const notifyListeners = (payload) => {
  listeners.forEach((listener) => {
    try {
      listener(payload);
    } catch (error) {
      console.error('Error in purchase event listener:', error);
    }
  });
};

const openSocket = (branchId) => {
  const normalized = String(branchId);
  if (!normalized) return;
  currentBranchId = normalized;
  clearReconnect();
  socket = new WebSocket(`wss://backend.chamafruits.com/ws2/${normalized}`);

  socket.onopen = () => {
    reconnectAttempts = 0;
  };

  socket.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      notifyListeners(data);
    } catch (error) {
      console.error('Error handling purchase WebSocket message:', error);
    }
  };

  socket.onclose = () => {
    socket = null;
    if (!currentBranchId) return;
    const delay = Math.min(10000, 1000 * 2 ** reconnectAttempts);
    reconnectAttempts += 1;
    reconnectTimer = setTimeout(() => {
      openSocket(currentBranchId);
    }, delay);
  };
};

export const startPurchaseEvents = (branchId) => {
  const normalized = branchId ? String(branchId) : '';
  if (!normalized) {
    if (socket) {
      socket.close();
      socket = null;
    }
    currentBranchId = null;
    clearReconnect();
    return;
  }
  if (socket && currentBranchId === normalized) return;
  if (socket) {
    socket.close();
    socket = null;
  }
  reconnectAttempts = 0;
  openSocket(normalized);
};

export const stopPurchaseEvents = () => {
  currentBranchId = null;
  clearReconnect();
  if (socket) {
    socket.close();
    socket = null;
  }
};

export const subscribePurchaseEvents = (listener) => {
  if (typeof listener !== 'function') return () => {};
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
